import { render, staticRenderFns } from "./UnsavedLeavePopup.vue?vue&type=template&id=5e2d77b2&scoped=true&"
import script from "./UnsavedLeavePopup.vue?vue&type=script&lang=js&"
export * from "./UnsavedLeavePopup.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedLeavePopup.vue?vue&type=style&index=0&id=5e2d77b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d77b2",
  null
  
)

export default component.exports